import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import AppStores from "./AppStores";
import React from "react";
import { JOIN_ERROR_UNAUTHORIZED } from "../constants/subscribe-modal";

export default function SubscribeModal(props) {
  const handleClose = () => props.setShowSubscribeModal(false);

  return (
    <Modal show={props.showSubscribeModal} onHide={handleClose}>
      <Modal.Body>{JOIN_ERROR_UNAUTHORIZED}</Modal.Body>
      <AppStores app="learn" />
      <Modal.Footer>
        <Button variant="primary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
